import React, { useState } from "react"
import { Form, FormSpy } from "react-final-form"

import { makeStyles } from "@mui/styles"

import { useDebouncedFields } from "./hooks/useDebouncedFields"
import index18n from "../../../../lib/i18n.es6"
import { Button } from "../../../molecules"
import { DEFAULT_FILTERS } from "../constants/defaultFilters"
import { getLocalStorageValues, setLocalStorageValues } from "../lib"

export const useStyles = makeStyles(() => ({
  filterForm: {
    "& > div:not(:last-of-type)": {
      marginBottom: "10px",
    },
  },
  resetFilters: {
    "&[class*='MuiButton-outlined']": {
      margin: "22px 0 0 0",
    },
  },
}))

export const Filters = ({ children, initialValues = {}, onChange, onReset, tableId, debouncedFields = [] }) => {
  const { filterForm, resetFilters } = useStyles()
  const [initialState] = useState(initialValues)
  const initialFormValues = getLocalStorageValues(tableId, "filters") || initialState
  const { debouncedFieldsChanged, handleDebouncedChange } = useDebouncedFields()

  return (
    <Form
      initialValues={{
        ...initialFormValues,
        [DEFAULT_FILTERS]: initialValues
      }}
      onSubmit={() => {
        // empty
      }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={filterForm}>
          <FormSpy
            subscriptions={{ values: true }}
            onChange={(props) => {
              setLocalStorageValues(tableId, "filters", props.values)

              if (debouncedFieldsChanged(props, debouncedFields)) {
                handleDebouncedChange(
                  () => onChange?.(props),
                  props,
                  debouncedFields
                )
                return
              }

              if (props.dirty) onChange?.(props)
            }}
          />
          {children}
          <Button
            label={index18n("General:ResetFilters")}
            variant={"outlined"}
            className={resetFilters}
            onClick={() => onReset({ ...initialState, [DEFAULT_FILTERS]: initialValues })}
          />
        </form>
      )}
    />
  )
}
